import React from 'react';
const testimonials = [{
  name: 'Elena P.',
  role: 'Maestra di Primaria, Milano',
  rating: 5,
  quote: "Finalmente ho recuperato i miei weekend! Le attività sono così belle che i bambini non vedono l'ora che arrivi l'ora di inglese. Investimento ripagato subito.",
  initial: 'E'
}, {
  name: 'Maria G.',
  role: 'Docente di ruolo, Napoli',
  rating: 5,
  quote: 'Il pacchetto sui giochi express è fantastico. Adesso gestisco anche le classi più difficili con un sorriso. Grazie di cuore!',
  initial: 'M'
}, {
  name: 'Stefania L.',
  role: 'Istituti Comprensivi, Roma',
  rating: 5,
  quote: 'Qualità grafica eccellente e progressione didattica perfetta. Molto meglio dei libri adottati dalla scuola. Lo consiglio a tutte le colleghe.',
  initial: 'S'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-bg-dark py-20 px-4" data-id="element-220">
      <div className="max-w-5xl mx-auto" data-id="element-221">
        <div className="text-center mb-12" data-id="element-222">
          <span className="inline-block bg-secondary/10 text-secondary border border-secondary/20 font-bold text-xs sm:text-sm px-4 py-1.5 rounded-full mb-4 tracking-wider uppercase" data-id="element-223">
            ⭐ Recensioni Verificate
          </span>
          <h2 className="text-3xl sm:text-5xl font-black text-text-main tracking-tight" data-id="element-224">
            Cosa dicono le maestre italiane
          </h2>
          <p className="text-text-sec text-base sm:text-lg mt-3" data-id="element-225">
            Oltre <span className="text-primary font-bold" data-id="element-226">1.200 maestre</span>{' '}
            hanno già scelto Inglese Pronta™
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-227">
          {testimonials.map((t, i) => <div key={i} className="bg-bg-alt rounded-2xl border border-border-light p-6 sm:p-7 flex flex-col gap-4 hover:border-primary/40 transition-colors" data-id="element-228">
              <div className="text-secondary text-lg" aria-label={`${t.rating} stelle`} data-id="element-229">
                {'⭐'.repeat(t.rating)}
              </div>
              <p className="text-text-main text-base leading-relaxed font-medium italic flex-1" data-id="element-230">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-3 pt-4 border-t border-border-light" data-id="element-231">
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-primary to-orange-600 flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-232">
                  {t.initial}
                </div>
                <div className="min-w-0" data-id="element-233">
                  <p className="text-text-main font-bold text-sm" data-id="element-234">{t.name}</p>
                  <p className="text-text-sec text-xs leading-tight" data-id="element-235">
                    {t.role}
                  </p>
                </div>
                <span className="ml-auto text-check-green text-[10px] font-bold uppercase tracking-wider flex items-center gap-1 flex-shrink-0" title="Acquisto verificato" data-id="element-236">
                  ✓
                </span>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}